import React from 'react';
import { Label } from './ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { FileText } from 'lucide-react';

export default function ConventionPaymentDetailModal({ showDetailModal, setShowDetailModal, selectedConvention, formatMoney, formatDate, getStatusBadge, getMethodBadge }) {
  return (
      <Dialog open={showDetailModal} onOpenChange={setShowDetailModal}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileText className="h-5 w-5" />
              Détails du paiement
            </DialogTitle>
          </DialogHeader>
          
          {selectedConvention && (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-gray-500">Convention</Label>
                  <p className="font-medium">{selectedConvention.titre || 'Sans titre'}</p>
                </div>
                <div>
                  <Label className="text-gray-500">Numéro</Label>
                  <p className="font-mono">{selectedConvention.numero_contrat || '-'}</p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-gray-500">Destinataire</Label>
                  <p>{selectedConvention.destinataire_nom || '-'}</p>
                  <p className="text-sm text-gray-500">{selectedConvention.destinataire_email}</p>
                </div>
                <div>
                  <Label className="text-gray-500">Montant</Label>
                  <p className="text-xl font-bold text-blue-600">
                    {formatMoney(selectedConvention.montant)}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-gray-500">Statut</Label>
                  <div className="mt-1">
                    {getStatusBadge(selectedConvention.payment_status)}
                  </div>
                </div>
                <div>
                  <Label className="text-gray-500">Méthode</Label>
                  <div className="mt-1">
                    {getMethodBadge(selectedConvention.payment_method)}
                  </div>
                </div>
              </div>

              {selectedConvention.virement_reference && (
                <div>
                  <Label className="text-gray-500">Référence virement</Label>
                  <p className="font-mono bg-gray-100 px-2 py-1 rounded">
                    {selectedConvention.virement_reference}
                  </p>
                </div>
              )}

              {selectedConvention.stripe_session_id && (
                <div>
                  <Label className="text-gray-500">Session Stripe</Label>
                  <p className="font-mono text-xs bg-gray-100 px-2 py-1 rounded truncate">
                    {selectedConvention.stripe_session_id}
                  </p>
                </div>
              )}

              <div className="grid grid-cols-2 gap-4 pt-4 border-t">
                <div>
                  <Label className="text-gray-500">Date création</Label>
                  <p className="text-sm">{formatDate(selectedConvention.created_at)}</p>
                </div>
                <div>
                  <Label className="text-gray-500">Date paiement</Label>
                  <p className="text-sm">
                    {formatDate(selectedConvention.payment_validated_at || selectedConvention.payment_initiated_at)}
                  </p>
                </div>
              </div>

              {selectedConvention.payment_validated_by && (
                <div>
                  <Label className="text-gray-500">Validé par</Label>
                  <p className="text-sm">{selectedConvention.payment_validated_by}</p>
                </div>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
  );
}
